var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ca552fab-74e1-47bd-b465-eee1225a7479",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m35.196,17.018h-10.392c-.828,0-1.5-.671-1.5-1.5s.672-1.5,1.5-1.5h10.392c.828,0,1.5.671,1.5,1.5s-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#95e2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.85,11.676c.256,0,.464.208.464.464v35.721c0,.256-.208.464-.464.464h-17.699c-.256,0-.464-.208-.464-.464V12.14c0-.256.208-.464.464-.464h17.699m0-4h-17.699c-2.465,0-4.464,1.999-4.464,4.464v35.721c0,2.465,1.999,4.464,4.464,4.464h17.699c2.465,0,4.464-1.999,4.464-4.464V12.14c0-2.465-1.999-4.464-4.464-4.464h0Z",
    style: {
      fill: "#95e2c2"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.3bfed6c4c6444d8f5377940688d9c3f3.svg";
export { ForwardRef as ReactComponent };